module.exports = "/_next/static/images/155a970b84fa68f49a7c5118a7b85dc5-purple-help-icon.svg.webp";